export const PerformanceDashboardsIcon = () => (
    <img className='w-8 h-8' src={`${window.location.origin}/icons/28px_PerformanceDash.svg`} alt="Performance Dashboard" />
);
